export const CLEAR_PILOTAGE_DATA = 'CLEAR_PILOTAGE_DATA'

export const clearPilotageData = () => ({
  type: CLEAR_PILOTAGE_DATA,
})
